import { FilteredObservable } from "./FilteredObservable.js";
import { isObservable } from "./typeGuards.js";
export function filterObservable(arg0, arg1) {
    if (isObservable(arg0)) {
        if (arg1) {
            return new FilteredObservable(arg0, arg1);
        }
        else {
            throw new Error("Predicate function is required when passing an observable.");
        }
    }
    return (observable) => filterObservable(observable, arg0);
}
